import { render, staticRenderFns } from "./OrderInList.vue?vue&type=template&id=ec61f884&scoped=true"
import script from "./OrderInList.vue?vue&type=script&lang=js"
export * from "./OrderInList.vue?vue&type=script&lang=js"
import style0 from "./OrderInList.vue?vue&type=style&index=0&id=ec61f884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec61f884",
  null
  
)

export default component.exports